module.exports = {
	"name": "timestampconverter",
	"version": "1.11.1",
	"description": "A convenient web application to convert timestamps into ISO strings and the other way around",
	"author": "Jos de Jong <wjosdejong@gmail.com>",
	"license": "UNLICENSED",
	"keywords": [
		"unix",
		"timestamp",
		"ISOString",
		"converter",
		"date",
		"time",
		"timezone",
		"epoch"
	],
	"scripts": {
		"start": "node build/dev-server.js",
		"build": "node build/build.js && cp BingSiteAuth.xml dist&& cp googlea47c4a0b36d11021.html dist && cp ads.txt dist ",
		"deploy": "npm test && npm run build && aws s3 sync --delete dist/ s3://tttimestamps.com --acl public-read",
		"unit": "cross-env BABEL_ENV=test karma start test/unit/karma.conf.js --single-run",
		"test-watch": "cross-env BABEL_ENV=test karma start test/unit/karma.conf.js",
		"test": "npm run unit",
		"lint": "eslint --ext .js,.vue src test/unit/specs"
	},
	"dependencies": {
		"es6-shim": "0.35.3",
		"material-datetime-picker": "2.4.0",
		"moment": "2.22.2",
		"moment-timezone": "0.5.23",
		"named-js-regexp": "1.3.2",
		"shortid": "2.2.8",
		"vue": "2.2.4",
		"vue-focus": "2.1.0",
		"vue2-dragula": "2.4.4"
	},
	"devDependencies": {
		"autoprefixer": "6.7.7",
		"babel-core": "6.24.0",
		"babel-eslint": "7.1.1",
		"babel-loader": "6.4.1",
		"babel-plugin-istanbul": "4.0.0",
		"babel-plugin-transform-runtime": "6.23.0",
		"babel-preset-es2015": "6.24.0",
		"babel-preset-stage-2": "6.22.0",
		"babel-register": "6.24.0",
		"chai": "3.5.0",
		"chalk": "1.1.3",
		"connect-history-api-fallback": "1.3.0",
		"cross-env": "3.2.4",
		"css-loader": "0.27.3",
		"eslint": "3.17.1",
		"eslint-config-standard": "7.0.1",
		"eslint-friendly-formatter": "2.0.7",
		"eslint-loader": "1.6.3",
		"eslint-plugin-html": "2.0.1",
		"eslint-plugin-promise": "3.5.0",
		"eslint-plugin-standard": "2.1.1",
		"eventsource-polyfill": "0.9.6",
		"express": "4.15.2",
		"extract-text-webpack-plugin": "1.0.1",
		"file-loader": "0.10.1",
		"friendly-errors-webpack-plugin": "1.6.1",
		"function-bind": "1.1.0",
		"html-webpack-plugin": "2.28.0",
		"http-proxy-middleware": "0.17.4",
		"inject-loader": "2.0.1",
		"json-loader": "0.5.4",
		"karma": "1.5.0",
		"karma-coverage": "1.1.1",
		"karma-mocha": "1.3.0",
		"karma-phantomjs-launcher": "1.0.4",
		"karma-sinon-chai": "1.2.4",
		"karma-sourcemap-loader": "0.3.7",
		"karma-spec-reporter": "0.0.30",
		"karma-webpack": "2.0.3",
		"lodash": "4.17.4",
		"lolex": "1.6.0",
		"mocha": "3.2.0",
		"node-sass": "4.10.0",
		"offline-plugin": "4.8.4",
		"opn": "4.0.2",
		"ora": "1.1.0",
		"phantomjs-prebuilt": "2.1.14",
		"sass-loader": "6.0.3",
		"semver": "5.3.0",
		"shelljs": "0.7.7",
		"sinon": "1.17.7",
		"sinon-chai": "2.8.0",
		"url-loader": "0.5.8",
		"vue-loader": "11.1.4",
		"vue-style-loader": "2.0.4",
		"vue-template-compiler": "2.2.4",
		"webpack": "1.14.0",
		"webpack-dev-middleware": "1.10.1",
		"webpack-hot-middleware": "2.17.1",
		"webpack-merge": "2.0.0"
	},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	}
};


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 171
// module chunks = 0